import React from 'react';

import SetTopBox from './svgs/SetTopBox';
import Gateway from './svgs/Gateway';

const DefaultDeviceImage = (props) => {
  const { deviceType } = props;

  if (deviceType === 'SET_TOP_BOX' || deviceType === 'TV Box') return <SetTopBox />;

  return <Gateway />;
};

export default DefaultDeviceImage;
